export const user = {
  email: "Email",
  employeeNumber: "Employee Number",
  firstName: "First Name",
  lastName: "Last Name",
  password: "Password",
  confirmPassword: "Confirm Password",
  name: "Name",
  phoneNumber: "Phone Number",
  role: "Role",
  emergencyContact: "Emergency Contact",
  emergencyContactNumber: "Emergency Contact Number",
  photo: "Photo",
  countryRegion: "Region",
  companyName: "Company Name",
  companyAddress: "Company Address",
  ZIPCode: "ZIP Code",
  timeZone: "Time Zone",
  unitOfMeasure: "Unit of Measure",
  timeFormat: "Time Format",
  portalLanguage: "Portal Language",
  fleet: "Fleet",
  YYYYMMDD: "YYYY-MM-DD",
  MMDDYYYY: "MM-DD-YYYY",
  DDMMYYYY: "DD-MM-YYYY",
  chineseSimplified: "Chinese (Simplified)",
  chineseTraditional: "Chinese (Traditional)",
  english: "English",
  japanese: "Japanese",
  italian: "Italian",
  german: "German",
  french: "French",
  spanishes: "Spanishes",
  pleaseInputEmail: "Please input an Email",
  notValidEmailAddress: "Invalid Email address",
  pleaseInputName: "Please input a user name",
  pleaseInputPassword: "Please input a password",
  pleaseInputCompanyName: "Please input a company name",
  pleaseInputCompanyAddress: "Please input a company address",
  pleaseInputZIPCode: "Please input a ZIP Code",
  pleaseSelectRole: "Please select a role",
  pleaseInputPhoneNumber: "Please input a phone number",
  pleaseInputCertExpireTime: "Please input driver license expire time",
  failedToSaveEmailAlreadyExist: "Failed to save. The Email already exists.",
  failedToSaveEmployeeNumberAlreadyExist:
    "Failed to save. The employee number already exists.",
  failedToSavePhoneNumberAlreadyExist:
    "Failed to save. The phone number already exists.",
  failedToSaveEmailInvalid: "Failed to save. The Email is invalid.",
  failedToSaveUploadPhotoFailed: "Failed to save. Upload photo failed.",
  failedToSaveRegistrationQuotaReached:
    "Can not add more accounts. The registration quota has been reached.",
  failedToNFCCardIDAlreadyExist:
    "Failed to save. The NFC Card ID already exists.",
  status: "Status",
  sendSuccessfully: "Sent successfully.",
  failedToSaveChangeRoleLastAdminFailed:
    "Failed to change the role. At least one Administrator account is required.",
  failedToDeleteUserLastAdminFailed:
    "Failed to delete. At least one Administrator account is required.",
  nextCycleScheduleDeleteUserTips: `This user account will exceed the number of user account licenses in the next billing cycle. This account will be deleted at the end of the current billing cycle.\r\n You can change the accounts to delete on the "Plan" page.`,
  userImport: "User Import",
  search: "Search",
  userSearchLimit: "Enter at least 1 characters",
  mobileSearchLimit: "Enter at least 3 digits",
  empNoSearchLimit: "Enter at least 2 characters",
  pleaseInputEmployNumber: "Please input a employee number",
  pleaseInputEmergencyContact: "Please input a Emergency Contact",
  pleaseInputEmergencyContactNumber: "Please input a Emergency Contact Number",
  failedToSaveDriverPhotoNotHasFRFeature:
    "Failed to save.The driver photo is not a Face ID photo.",
};
